import { endPoints, requestType } from "../../constants/Variables";
import Api from "../index";

const companySendCode = (params) => {
  return Api(endPoints.companySendCode, params, requestType.POST);
};

const registerCompany = (params) => {
  return Api(endPoints.registerCompany, params, requestType.POST);
};

const loginCompany = (params) => {
  return Api(endPoints.loginCompany, params, requestType.POST);
};

const getAllCompanies = () => {
  return Api(endPoints.getAllCompany, null, requestType.GET);
};

const updateCompanyProfile = (id, params) => {
  return Api(
    `${endPoints.updateCompanyProfile}/${id}`,
    params,
    requestType.PUT
  );
};
const updateCompanyServices = (id, params) => {
  return Api(
    `${endPoints.updateCompanyServices}/${id}`,
    params,
    requestType.PUT
  );
};

const changePasswordCompany = (params) => {
  return Api(endPoints.changePasswordCompany, params, requestType.POST);
};

const updateCompanySubscription = (id, params) => {
  return Api(
    `${endPoints.updateCompanySubscription}/${id}`,
    params,
    requestType.PUT
  );
};

const getCompanyCurrentSubscription = (id) => {
  return Api(
    `${endPoints.getCompanyCurrentSubscription}/${id}`,
    null,
    requestType.GET
  );
};

const getCompanyRelatedToServices = (payload) => {
  return Api(endPoints.getCompanyRelatedToServices, payload, requestType.POST);
};

const getCompanyDashboardStates = (id) => {
  return Api(
    `${endPoints.getCompanyDashboardStates}/${id}`,
    null,
    requestType.GET
  );
};

const getCompanyMonthlyEarning = (id) => {
  return Api(
    `${endPoints.getCompanyMonthlyEarning}/${id}`,
    null,
    requestType.GET
  );
};

const getCompanyAllClients = (id, name) => {
  return Api(
    `${endPoints.getCompanyAllClients}/${id}?search=${name || ""}`,
    null,
    requestType.GET
  );
};

const getCompanyReport = (id, query) => {
  return Api(
    `${endPoints.getCompanyReport}/${id}?startDate=${query.startDate}&endDate=${query.endDate}`,
    null,
    requestType.GET
  );
};

const companyPurchaseSubscripton = (params) => {
  return Api(endPoints.companyPurchaseSubscripton, params, requestType.POST);
};

const companyCanCreateWorker = (id) => {
  return Api(
    `${endPoints.companyCanCreateWorker}/${id}`,
    null,
    requestType.GET
  );
};

export {
  companySendCode,
  registerCompany,
  loginCompany,
  updateCompanyProfile,
  changePasswordCompany,
  updateCompanySubscription,
  updateCompanyServices,
  getCompanyCurrentSubscription,
  getAllCompanies,
  getCompanyRelatedToServices,
  getCompanyDashboardStates,
  getCompanyMonthlyEarning,
  getCompanyAllClients,
  getCompanyReport,
  companyPurchaseSubscripton,
  companyCanCreateWorker,
};
